import React from "react";

const Achievements = () => <div>Achievements</div>;

export default Achievements;
